import React, { Component } from "react";
import ReactDOM from "react-dom";
import _ from "lodash";
import { connect } from "react-redux";
import settings from "../../settings";
import PersonDetail from "./Platinum/PersonDetail";
import PlatinumAddressHistory from "./Platinum/PlatinumAddressHistory";
import CriminalReportSection from "./CriminalReportSection";
import BankruptciesLiensJudgmentsReportSection from "./BankruptciesLiensJudgmentsReportSection";
import SSNVerificationDetails from "./Platinum/SSNVerificationDetails";
import AKAsDetails from "./Platinum/AKAsDetails";
import Imposters from "./Platinum/Imposters";
import PeopleAtWorkReport from "./Platinum/PeopleAtWorkReport";
import UCCFiling from "./Platinum/UCCFiling";
import Associates from "./Platinum/Associates";
import LiensJudgements from "./Platinum/LiensJudgements";
import CorporateAffiliationsReport from "./Platinum/CorporateAffiliationsReport";
import DriverLiencesDetails from "./Platinum/DriverLiencesDetails";
import VoterRegistrations from "./Platinum/VoterRegistrations";
import NeighborsCurrent from "./Platinum/NeighborsCurrent";
import NeighborsHistorical from "./Platinum/NeighborsHistorical";
import CommonResidency from "./Platinum/CommonResidency";
import Properties from "./Platinum/Properties";
import Relatives from "./Platinum/Relatives";
import Watercrafts from "./Platinum/Watercrafts";
import Bankruptcies from "./Platinum/Bankruptcies";
import CriminalActionsSecondarySources from "./Platinum/CriminalActionsSecondarySources";
import HuntingFishingLicenses from "./Platinum/HuntingFishingLicenses";
import ConcealedWeaponsPermits from "./Platinum/ConcealedWeaponsPermits";
import FederalFirearms from "./Platinum/FederalFirearms";
import ProfessionalLicenses from "./Platinum/ProfessionalLicenses";
import Aircrafts from "./Platinum/Aircrafts";
import Foreclosures from "./Platinum/Foreclosures";
import SocialMediaSection from "./SocialMediaSection";
import EmailReportSection from "./EmailReportSection";
import MotorVehicles from "./Platinum/MotorVehicles";
import CriminalRecordsPrimarySource from "./Platinum/CriminalRecordsPrimarySource";
import {
  stickyNavInitialize,
  stickyNavInitializeContext,
} from "../../actions/stickyNavAction";
import Certificates from "./Platinum/Certificates";

class PersonPlatinumReport extends Component {
  constructor(props) {
    super(props);
    this.reportRefs = [];
    const { internalID, savedResultID } = props.additionalData;
    this.state = {
      savedResultID,
      internalID,
    };
  }

  componentDidMount() {
    this.loadData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.currentIndex !== undefined) {
      this.onReportIndexChanged(nextProps.currentIndex);
    }
    if (nextProps.additionalData !== null) {
      this.loadData(nextProps);
    }
  }

  onReportIndexChanged = (currentIndex) => {
    const reportRef = this.reportRefs[
      currentIndex < this.reportRefs.length ? currentIndex : 0
    ];
    const section = ReactDOM.findDOMNode(reportRef.current);
    if (section !== undefined && section !== null) {
      section.scrollIntoView();
    } else if (this.state.navs && this.state.navs.length > currentIndex) {
      const nav = this.state.navs[currentIndex];
      const element = document.getElementById(`nav_${nav.name}`);
      if (element) element.scrollIntoView();
    }
  };

  loadData = (props) => {
    if (this.state.navs) return;

    const navs = [];
    this.reportRefs = [];
    let reportTypes = settings.compPlusDefaultReportTypes;
    if (
      props.additionalData !== undefined &&
      props.additionalData.optReportType === "compplus"
    ) {
      reportTypes = settings.compPlusDefaultReportTypes;
    }
    const navRefMap = {};
    const defRef = React.createRef();
    navRefMap[settings.defaultSection.sectionName] = {
      name: settings.defaultSection.sectionName,
      display: settings.defaultSection.displayName,
      ref: defRef,
    };
    navs.push({
      name: settings.defaultSection.sectionName,
      display: settings.defaultSection.displayName,
      count: undefined,
    });
    this.reportRefs.push(defRef);

    _.forEach(settings.sectionReports, (rep) => {
      if (_.findIndex(reportTypes, (a) => a === rep.sectionName) !== -1) {
        const ref = React.createRef();
        navRefMap[rep.sectionName] = {
          name: rep.sectionName,
          display: rep.displayName,
          ref,
        };
        navs.push({
          name: rep.sectionName,
          display: rep.displayName,
          count: undefined,
        });
        this.reportRefs.push(ref);
      }
    });

    const addonReports = props.additionalData.selectedReports
      ? props.additionalData.selectedReports
      : [];
    _.forEach(settings.addOnReports, (addonReport) => {
      const addonNode = _.get(
        props.reportData,
        `personReport.${addonReport.sectionName}s[0]`
      );
      if (addonNode) {
        addonReports.push(addonReport.sectionName);
      }
    });
    const addonReportSections = [];
    if (addonReports !== undefined && addonReports.length > 0) {
      const addOnref = React.createRef();
      navRefMap.addonrepsep = {
        name: "addonrepsep",
        display: "Add On Reports",
        ref: addOnref,
      };
      navs.push({
        name: "addonrepsep",
        display: "Add On Reports",
        count: undefined,
      });
      this.reportRefs.push(addOnref);
      _.forEach(settings.addOnReports, (rep) => {
        if (_.findIndex(addonReports, (a) => a === rep.sectionName) !== -1) {
          const ref = React.createRef();
          navRefMap[rep.sectionName] = {
            name: rep.sectionName,
            display: rep.displayName,
            ref,
            count: undefined,
          };
          this.reportRefs.push(ref);
          navs.push({
            name: rep.sectionName,
            display: rep.displayName,
            count: undefined,
          });
        }
      });
      const personResult = _.get(props.reportData, "personReport.person[0]");
      if (addonReports.length > 0) {
        for (let i = 0; i < addonReports.length; i += 1) {
          const addOnReference = navRefMap[addonReports[i]].ref;
          if (addonReports[i] === "crimaddon") {
            addonReportSections.push(
              <CriminalReportSection
                {...props}
                node={personResult}
                sectionName={navRefMap.crimaddon.name}
                key={`addon_${i}`}
              />
            );
          } else if (addonReports[i] === "bljaddon") {
            addonReportSections.push(
              <BankruptciesLiensJudgmentsReportSection
                {...this.props}
                node={personResult}
                sectionName={navRefMap.bljaddon.name}
                key={`addon_${i}`}
              />
            );
          } else if (addonReports[i] === "mvraddon") {
            addonReportSections.push(
              <MotorVehicles
                ref={addOnReference}
                {...props}
                node={personResult}
                sectionName={navRefMap.mvraddon.name}
                updateItemCountBySection={this.updateItemCountBySection}
                key={`addon_${i}`}
              />
            );
          } else if (addonReports[i] === "mvraddonplat") {
            addonReportSections.push(
              <MotorVehicles
                ref={addOnReference}
                {...props}
                node={personResult}
                sectionName={navRefMap.mvraddonplat.name}
                updateItemCountBySection={this.updateItemCountBySection}
                key={`addon_${i}`}
              />
            );
          }
        }
      }
    }

    const { internalID, savedResultID } = props.additionalData;
    this.setState({
      reportTypes,
      navRefMap,
      addonReportSections,
      internalID,
      savedResultID,
      navs,
    });
    const stickyNav = props.stickyNav;
    stickyNav.navs = navs;
    props.stickyNavInitialize(stickyNav);
    this.onReportIndexChanged(1);
  };

  updateItemCountBySection = (sectionName, count) => {
    const stickyNav = this.props.stickyNav;
    const navs = stickyNav.navs;
    const currentSection = _.find(navs, (n) => n.name === sectionName);
    if (currentSection !== undefined) {
      currentSection.count = count;
    }
    stickyNav.navs = navs;

    this.props.stickyNavInitializeContext(stickyNav);
  };

  render() {
    const { reportData } = this.props;
    const personResult = _.get(reportData, "personReport.person[0]");
    let navRefMapLength = 0;
    if (this.state !== null && this.state.navRefMap !== undefined) {
      navRefMapLength = Object.keys(this.state.navRefMap).length;
    }
    return (
      <div ref={this.props.stickyNav.handleContextRef} id={`report`}>
        {this.state && this.state.navRefMap && (
          <div>
            <PersonDetail
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap[settings.defaultSection.sectionName]
                      .ref
                  : undefined
              }
              {...this.props}
            />
            <PlatinumAddressHistory
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.addresshistory.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.addresshistory.name}
              node={personResult}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <SSNVerificationDetails
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.ssnverification.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.ssnverification.name}
              node={personResult}
            />
            <AKAsDetails
              ref={
                navRefMapLength > 0 ? this.state.navRefMap.akas.ref : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.akas.name}
              node={personResult}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <Imposters
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.imposters.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.imposters.name}
              node={personResult}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <PeopleAtWorkReport
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.people_at_work.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.people_at_work.name}
              node={personResult}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <UCCFiling
              ref={
                navRefMapLength > 0 ? this.state.navRefMap.ucc.ref : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.ucc.name}
              node={personResult}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <Associates
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.associates.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.associates.name}
              sectionTitle={this.state.navRefMap.associates.display}
              node={personResult}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <LiensJudgements
              ref={
                navRefMapLength > 0 ? this.state.navRefMap.liens.ref : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.liens.name}
              node={personResult}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <CorporateAffiliationsReport
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.affiliations.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.affiliations.name}
              node={personResult}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <DriverLiencesDetails
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.driverLicense.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.driverLicense.name}
              node={personResult}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <VoterRegistrations
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.voterregistrations.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.voterregistrations.name}
              node={personResult}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <NeighborsCurrent
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.neighbors.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.neighbors.name}
              node={personResult}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <NeighborsHistorical
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.historicalneighbors.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.historicalneighbors.name}
              node={personResult}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <CommonResidency
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.commonresidency.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.commonresidency.name}
              node={personResult}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <Properties
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.properties.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.properties.name}
              node={personResult}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <Relatives
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.relatives.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.relatives.name}
              node={personResult}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <Watercrafts
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.watercrafts.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.watercrafts.name}
              node={personResult}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <HuntingFishingLicenses
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.huntingfishing.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.huntingfishing.name}
              node={personResult}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <ConcealedWeaponsPermits
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.weapon.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.weapon.name}
              node={personResult}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <FederalFirearms
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.firearm.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.firearm.name}
              node={personResult}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <ProfessionalLicenses
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.professionallicenses.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.professionallicenses.name}
              node={personResult}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <Aircrafts
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.aircraft.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.aircraft.name}
              node={personResult}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <Certificates
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.faacertificates.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.faacertificates.name}
              node={personResult}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <Foreclosures
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.foreclosures.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.foreclosures.name}
              node={personResult}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <Bankruptcies
              ref={
                navRefMapLength > 0 ? this.state.navRefMap.bank.ref : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.bank.name}
              node={personResult}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <CriminalActionsSecondarySources
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.crimsec.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.crimsec.name}
              node={personResult}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <CriminalRecordsPrimarySource
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.criminal.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.criminal.name}
              node={personResult}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <EmailReportSection
              ref={
                navRefMapLength > 0 ? this.state.navRefMap.email.ref : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.email.name}
              node={personResult}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <SocialMediaSection
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.social.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.social.name}
              node={personResult}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            {this.state.addonReportSections}
            <br />
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentIndex: state.nav.currentIndex,
    stickyNav: state.stickyNav,
    userAccount: state.userAccount,
  };
}

export default connect(mapStateToProps, {
  stickyNavInitialize,
  stickyNavInitializeContext,
})(PersonPlatinumReport);



// WEBPACK FOOTER //
// ./src/components/reports/PersonPlatinumReport.js